import ActiveValues from '$constants/ActiveValues';

export default function getEmptyResultsText(
  activeTab: ActiveValues,
  t: (str: string) => string
): { title: string; description: string } {
  const emptyResultsText = {
    [ActiveValues.All]: {
      title: t('EmployerPositions.NoCandidatesAsigned'),
      description: t('EmployerPositions.NoCandidatesSubtext'),
    },
    [ActiveValues.New]: {
      title: t('EmployerPositions.NoCandidatesAsigned'),
      description: t('EmployerPositions.NoCandidatesSubtext'),
    },
    [ActiveValues.ShortList]: {
      title: t('EmployerPositions.NoShortListText'),
      description: t('EmployerPositions.NoShortListDescription'),
    },
    [ActiveValues.OfferSent]: {
      title: t('EmployerPositions.NoOfferSentText'),
      description: t('EmployerPositions.NoOfferSentDescription'),
    },
    [ActiveValues.requestInterview]: {
      title: t('EmployerPositions.NoInterviewRequestedText'),
      description: t('EmployerPositions.NoInterviewRequestedDescription'),
    },
    [ActiveValues.find]: {
      title: t('SimeraInternal.EmptyState'),
      description: '',
    },
    [ActiveValues.hired]: {
      title: t('SimeraInternal.EmptyState'),
      description: '',
    },
    [ActiveValues.declined]: {
      title: t('SimeraInternal.EmptyState'),
      description: '',
    },
    [ActiveValues.interested]: {
      title: t('SimeraInternal.EmptyState'),
      description: '',
    },
  };

  const defaultTitle = {
    title: t('SimeraInternal.EmptyState'),
    description: '',
  };

  return emptyResultsText[activeTab] || defaultTitle;
}
